import { useEffect, useState } from "react";
import { useToast } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import {
  getPlayers,
  TopScorersResponse,
  getOwnGoals,
  OwnGoalEntry,
} from "../../Services/home";
import { RootState } from "../../Store/store";

export const useHome = () => {
  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState<TopScorersResponse>();
  const [error, setError] = useState<string | null>(null);
  const [retryCount, setRetryCount] = useState(0);
  const [ownGoals, setOwnGoals] = useState<OwnGoalEntry[] | undefined>(
    undefined
  );

  const { season } = useSelector((state: RootState) => state);

  const toast = useToast();

  useEffect(() => {
    const seasonId = season?.data?.id;
    if (!seasonId) return;

    const fetchPlayers = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getPlayers(seasonId);
        setPlayers(response);
        setRetryCount(0);
      } catch (err) {
        if (retryCount < 1) {
          setRetryCount(retryCount + 1);
          fetchPlayers();
        } else {
          setError("Ocorreu um erro ao buscar os jogadores.");
        }
      } finally {
        setLoading(false);
      }
    };

    const fetchOwnGoals = async () => {
      try {
        const own = await getOwnGoals(seasonId);
        setOwnGoals(own);
      } catch (ownErr) {
        console.error("Erro ao buscar gols contra:", ownErr);
        setOwnGoals(undefined);
      }
    };

    fetchPlayers();
    fetchOwnGoals();
  }, [season?.data?.id, retryCount]);

  useEffect(() => {
    if (error) {
      toast({
        title: "Erro",
        description: error,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [error, toast]);

  return {
    loading,
    players,
    ownGoals,
    error,
  };
};
